import React, { Component } from "react";
import { DKLabel, DKIcon, DKCheckMark } from "deskera-ui-library";
import Incrementor from "../../common/Incrementor";

/*
PROPS
- data // this is current components data
- onDataChange
- className
*/

class SocialSectionEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div
        className={
          "column parent-width border-box mt-m border-radius-s p-r border-m shadow-s " +
          this.props.className
        }
      >
        {this.getAllItems(this.componentData.value)}
        <Incrementor
          className=""
          title="Icon size"
          value={this.componentData.style.iconSize}
          onChange={(value) => {
            this.changeStyle("iconSize", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Icon spacing"
          value={this.componentData.style.cellSpacing}
          onChange={(value) => {
            this.changeStyle("cellSpacing", value);
          }}
        />
      </div>
    );
  }

  getAllItems(items) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getItemRow(item, index));
    });
    return arr;
  }
  getItemRow(item, index) {
    return (
      <div className="column parent-width mb-l">
        <div
          className="row cursor-hand"
          style={{ width: "auto" }}
          onClick={() => {
            this.changeValue("isRequired", !item.isRequired, index);
          }}
        >
          <DKIcon src={item.icon} className="mr-s ic-s-2 unselectable" />
          <DKLabel text={item.title} className="unselectable" />
          <DKCheckMark className="ml-r" isSelected={item.isRequired} />
        </div>
        <input
          className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m mt-s"
          type="text"
          value={item.url}
          onChange={(e) => this.changeValue("url", e.target.value, index)}
          placeholder="https://www.example.com"
        />
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  changeValue = (property, value, index) => {
    let new_value = this.componentData.value;
    new_value[index][property] = value;
    this.componentData.value = new_value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default SocialSectionEditor;
